import * as React from 'react'
import { Link } from 'react-router-dom'
import { Box, Card, CardActions, Button, Typography } from '@mui/material'
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined'
import BentoIcon from '@mui/icons-material/BentoOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined'
import OutboxIcon from '@mui/icons-material/Outbox'
import { ENV_BASED_CONSTANTS } from '../utils/constants'
import mfhLogo from './mfhLogo.png'

const Welcome = () => {
  return (
    <Card
      sx={{
        background: (theme) =>
          theme.palette.mode === 'dark'
            ? '#535353'
            : `linear-gradient(to right, #0c4258 0%, #52aef4 35%), linear-gradient(to bottom, #0c4258 0%, #52aef4 50%), #0c4258`,

        color: '#fff',
        padding: '20px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Box display="flex">
        <Box flex="1">
          <Typography variant="h5" component="h1" gutterBottom>
            MaleFromHome Provider Portal - Post-Vasectomy Testing Results
          </Typography>

          <br />
          <br />

          <Box display="flex" gap={2}>
            <Button
              variant="contained"
              to="/provider-portal/providers"
              component={Link}
              size="large"
              color="success"
              startIcon={<ViewListOutlinedIcon />}
            >
              View Results by Provider
            </Button>

            <Button
              variant="contained"
              to="/provider-portal/bulk-orders"
              component={Link}
              size="large"
              color="info"
              startIcon={<ShoppingBagOutlinedIcon />}
            >
              View Results from Bulk Orders
            </Button>

            <Button
              variant="contained"
              to="/provider-portal/kit-requests"
              component={Link}
              size="large"
              color="primary"
              startIcon={<OutboxIcon />}
            >
              Kit Requests - Ship Directly to Patient
            </Button>
          </Box>

          <br />
          <br />
          <br />

          <CardActions
            sx={{
              padding: { xs: 0, xl: null },
              flexWrap: { xs: 'wrap', xl: null },
              '& a': {
                marginTop: { xs: '1em', xl: null },
                marginLeft: { xs: '0!important', xl: null },
                marginRight: { xs: '1em', xl: null },
              },
            }}
          >
            <Button
              variant="contained"
              href={ENV_BASED_CONSTANTS.patientBrochures}
              target="_blank"
              size="small"
              startIcon={<BentoIcon />}
            >
              Request Free Referral Cards
            </Button>
            <Button
              variant="contained"
              href={ENV_BASED_CONSTANTS.bulkSpecimenKits}
              target="_blank"
              size="small"
              startIcon={<Inventory2OutlinedIcon />}
            >
              Purchase Bulk Testing Kits
            </Button>
          </CardActions>

          <br />

          <Box maxWidth="40em">
            <Typography variant="body1" component="p" gutterBottom>
              Contact MaleFromHome Provider Support: <a href="mailto:providers@malefromhome.com">providers@malefromhome.com</a>
            </Typography>
          </Box>
        </Box>
        <Box
          display={{ xs: 'none', sm: 'none', md: 'block' }}
          sx={{
            background: `url(${mfhLogo}) top right / cover`,
            marginLeft: 'auto',
          }}
          width="16em"
          height="16em"
          overflow="hidden"
        />
      </Box>
    </Card>
  )
}

export default Welcome
